export default __webpack_public_path__ + "static/media/028-brachiosaurus.8ed82171.svg";